import script from "./ColumnConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./ColumnConfiguration.vue?vue&type=style&index=0&id=54e9396f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e9396f"]])

export default __exports__